import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from "../../services/notification.service";

import { DataService } from '../../data.service';
import { UrlConstant } from '../../constants/url-constant';
import { GlobalConstant } from '../../constants/global-constant';
import { AppData } from '../../constants/app-data';
import { HeaderComponent } from '../header/header.component';

// Reference: Localstorage => https://alligator.io/js/introduction-localstorage-sessionstorage/

@Component({
  //selector: 'app-login',
  //selector: 'router-outlet',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
	message = "";
	
  form: FormGroup;
  public loginInvalid: boolean;
  private formSubmitAttempt: boolean;
  private returnUrl: string;
  
  constructor(private fb: FormBuilder, private formModule: ReactiveFormsModule, private route: ActivatedRoute,
//    private authService: AuthService,
	public notificationService: NotificationService,
    private router: Router,  private header: HeaderComponent,
       public appData: AppData,   private dataService: DataService
    ) { }
    

  ngOnInit(): void {
  	this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/game';
    this.form = this.fb.group({
      //username: ['', Validators.email],
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
//    if (await this.authService.checkAuthenticated()) {
//      await this.router.navigate([this.returnUrl]);
//    }
  }


  onSubmit() {
  	this.loginInvalid = false;
    this.appData.loginInvalid.next(false);
    this.formSubmitAttempt = false;
    if (this.form.valid) {
      try {
        const username = this.form.get('username').value;
        const password = this.form.get('password').value;
//        await this.authService.login(username, password);
		this.sendLoginRequest(username, password);
      } catch (err) {
      	this.loginInvalid = true;
        this.appData.loginInvalid.next(true);
        console.log(err);
      }
    } else {
      this.formSubmitAttempt = true;
    }
  }
	
  public async sendLoginRequest(username:string, password:string){
  	var reqBody = {"userId":username, "password":password};
  	await this.dataService.sendPostRequestWithBody(UrlConstant.apiLogin ,reqBody).toPromise().then((data: any)=>{
	      //console.log(data);
	      this.message = data;
	      if("SUCCESS" === data.statusCode){
	      	//console.log("success code"); 
	      	if(data.loginUserStatus === "FORCE-PASSWORD-CHANGE"){
				var tempData = { 'userId': username, 'token': data.token, 'loginUserStatus': 'FORCE-PASSWORD-CHANGE' };
				this.dataService.setToLocalStorage(GlobalConstant.KEY_LOCAL_STORAGE_LOGIN_TEMP_DATA, tempData);
	      		this.router.navigate(['/changePassword', { 'userId': username, 'token': data.token, 'loginUserStatus': 'FORCE-PASSWORD-CHANGE' }]);
	      		return;
	      	} else if(data.loginUserStatus !== "ACTIVE"){
	      		this.notificationService.error("User is not Active.");
	      		return;
	      	}
	      	
	      	this.loginInvalid = false;
	      	this.appData.loginInvalid.next(false);
      		this.appData.isAuthenticated.next(true);
      		this.appData.userId = username;
      		this.appData.loginSuccessToken = data.token;
      		
      		if (window.localStorage) {
			  console.log('localStorage supported');
			  this.dataService.setApiKeyHeaderToLocalStorage(data.token);
			}
			
			//this.dataService.getLoggedInUserData({"userId": username });
			this.dataService.getLoggedInUserDataWithAllPrivileges({"userId": username });
	    	this.dataService.getStaticData({});
      		this.router.navigate(['/dashboard', { 'userId': username }]);
	      } else {
      		this.loginInvalid = true;
      		this.appData.loginInvalid.next(true);
      		this.appData.isAuthenticated.next(false);
      		//this.router.navigate(['/dashboard', { 'userId': username }]);
	      }
	    });
  }
  

}
